import { useRequest } from 'features/request/useRequest';
import type { CatalogItemDataFilterInput } from 'gql/graphql';

import { useMemo } from 'react';

import { uerCatalogsGql } from '../ContractQueries';

const requestId = 'uerCatalogs';

export const useContractCatalog = (filterWhere?: CatalogItemDataFilterInput | null | undefined, withEffect = true) => {
    const variables = useMemo(() => (filterWhere ? { where: filterWhere } : undefined), [filterWhere]);

    const [data, status] = useRequest({
        requestId,
        query: uerCatalogsGql,
        variables,
        withEffect,
    });

    const items = useMemo(() => data?.uerCatalogs?.items ?? [], [data?.uerCatalogs?.items]);

    return {
        status,
        items,
    };
};
